import * as z from "zod";
import { V2AdminProductIdSchema } from "./admin-products";

export const unarchiveOnboardingV2Product = {
  name: "unarchiveOnboardingV2Product" as const,
  input: z.object({
    teamId: z.string().min(1),
    productId: V2AdminProductIdSchema,
  }),
  output: z.object({ success: z.boolean() }),
};

export type UnarchiveOnboardingV2ProductInput = z.infer<
  typeof unarchiveOnboardingV2Product.input
>;
export type UnarchiveOnboardingV2ProductOutput = z.infer<
  typeof unarchiveOnboardingV2Product.output
>;
